<template>
  <bf-row
    v-if="!isMobile && data?.length > 0"
    type="flex"
    class="footer-fixed"
    :class="{ 'footer-pc': !isMobile }"
  >
    <div
      v-if="isLoading"
      class="w-100 justify-content-center text-center align-content-center"
    >
      <bf-icon name="loading" :spin="true"/>
    </div>
    <div v-else class="layout-flex-container"
      :key="$i18n.local"
      :data-local="`SDFSF-${$i18n.locale}`">
      <bf-carousel :items="1" dots mouse-drag class="w-100">
        <bf-carousel-item  v-for="item in data" :key="item?.title">
          <div>
            <div class="text-m text-bold mb-xs text-black">{{ item?.title }}</div>
            <p class="d-flex">
              {{ item?.message }}
              <bf-link v-if="item?.link">
                <a
                  :href="`#${item?.link}`"
                  target="_blank"
                  @click.prevent="showDocFrame(item?.link, item?.title)"
                > {{ $t('common.readmore') }}</a>
              </bf-link>
            </p>
          </div>
        </bf-carousel-item>
      </bf-carousel>
    </div>
  </bf-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { showDocFrame } from '@/utils/common';

export default {
  name: 'FooterAds',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('device', [
      'isMobile',
    ]),
  },
  methods: {
    showDocFrame,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/_variables';

.footer-fixed {
  background: rgb(255 255 255 / 100%);
  backdrop-filter: blur(5px);
  min-height: $footer-height;
  max-width: 100%;
  padding-top: $gutter;
  :deep() {
    .owl-theme .owl-nav.disabled + .owl-dots {
      margin-top: -($gutter/2);
      padding-top: $gutter/2;
    }
    .owl-carousel .owl-dots.disabled {
      display: block;
    }
    .owl-theme .owl-dots .owl-dot span {
      background: #D9E5FF;
    }
    .owl-theme .owl-dots .owl-dot.active span {
      background: $primaryColor;
    }
    .bf-carousel .nav {
      border-color: transparent;
      background: transparent;
      color: #9E9E9E;
      margin-top: -1*($gutter/2);
      // chevron-left
      &.prev .bf-icon:before {
        content: "\E91D";
      }
      // chevron-right
      &.next .bf-icon:before {
        content: "\E91E";
      }
      &:hover i, &:active i{
        color: #424242;
      }
    }
    .bf-carousel .nav.prev {
      left: auto;
      right: $gutter;
    }
  }
}
.footer-fixed.footer-pc {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
